import { render, staticRenderFns } from "./DialogConfirm.vue?vue&type=template&id=4bcdc838&scoped=true"
import script from "./DialogConfirm.vue?vue&type=script&lang=ts"
export * from "./DialogConfirm.vue?vue&type=script&lang=ts"
import style0 from "./DialogConfirm.vue?vue&type=style&index=0&id=4bcdc838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcdc838",
  null
  
)

export default component.exports